import { createApi } from '@reduxjs/toolkit/query/react'

import { NotificationController } from 'core-components/library/popup'
import { proxyIdentity } from 'src/core/classes/helpers/UrlHelper'
import { ISimulationRoles } from 'src/core/classes/models/ISimulationRoles'
import { getCustomQuery } from 'src/core/store/service/helpers/getCustomQuery'
import { getResponseHandler } from 'src/core/store/service/helpers/getResponseHandler'
import { disableSimulation } from 'src/core/store/service/simulation/disableSimulation'
import Logger from 'src/core/utils/Logger'

export const simulationApi = createApi({
  reducerPath: '@app/api/simulation',
  baseQuery: getCustomQuery({
    storageKey: 'simulationData',
    baseUrl: proxyIdentity(`/mbe/api/v2`),
  }),
  tagTypes: ['SimulationRoles'],
  endpoints: (builder) => ({
    getSimulationRoles: builder.query<ISimulationRoles[], void>({
      query: () => {
        return {
          url: `/app/roles/simulations`,
          method: 'GET',
          responseHandler: getResponseHandler({
            prepareValue: (data) => {
              return data || []
            },
          }),
        }
      },
      providesTags: ['SimulationRoles'],
    }),
    updateSimulationData: builder.mutation<ISimulationRoles, { payload: object }>({
      query: ({ payload }) => ({
        url: `/app/roles/simulations`,
        method: 'PUT',
        body: payload,
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (err) {
          Logger.error('Failed to update simulation data:', err)
        }
      },
      invalidatesTags: ['SimulationRoles'],
    }),
    startSimulation: builder.mutation<string, string>({
      query: (email: string) => {
        return {
          url: `/user/simulations/${email}`,
          method: 'POST',
          body: {},
          responseHandler: getResponseHandler({
            errorHandler: () =>
              NotificationController.showError({ message: `Sorry, you can't simulate this user` }),
          }),
        }
      },
    }),
    stopSimulation: builder.mutation<void, void>({
      query: () => {
        return {
          url: `/user/simulations`,
          method: 'DELETE',
          responseHandler: getResponseHandler({
            // now method for stop simulation send 405 error code. Maybe we can remove this method from app
            errorHandler: () => disableSimulation(),
          }),
        }
      },
    }),
  }),
})

export const {
  useStopSimulationMutation,
  useStartSimulationMutation,
  useGetSimulationRolesQuery,
  useUpdateSimulationDataMutation,
} = simulationApi
